import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import Modal from "../ui/Modal.jsx";
import "../../../styles/analytics/report-modal.scss";

const DataGroupModal = ({ data, open, onClose, onSubmit }) => {
  const [campaignEdited, setCampaignEdited] = useState({
    title: "",
    comments: "",
    results: [
      {
        metric: "",
        value: "",
        countTowardsImpressions: false,
        countTowardsEngagement: false,
      },
    ],
  });

  useEffect(() => {
    if (open && data) {
      setCampaignEdited({ ...data });
    }

    if (!open) {
      setCampaignEdited({
        title: "",
        comments: "",
        results: [],
      });
    }
  }, [open, data]);

  const removeEntry = (index) => {
    setCampaignEdited({
      ...campaignEdited,
      results: campaignEdited.results.filter((res, indx) => index !== indx),
    });
  };

  const toggleCountTowards = (index, field) => {
    setCampaignEdited({
      ...campaignEdited,
      results: campaignEdited.results.map((res, indx) => {
        if (index === indx) {
          return {
            ...res,
            [field]: !res[field],
          };
        }
        return res;
      }),
    });
  };

  const handleUpdateField = (index, field, value) => {
    setCampaignEdited({
      ...campaignEdited,
      results: campaignEdited.results.map((res, indx) => {
        if (index === indx) {
          return {
            ...res,
            [field]: value,
          };
        }
        return res;
      }),
    });
  };

  const addEntry = () => {
    setCampaignEdited({
      ...campaignEdited,
      results: [
        ...campaignEdited.results,
        {
          metric: "",
          value: "",
          countTowardsImpressions: false,
          countTowardsEngagement: false,
        },
      ],
    });
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Details"
      styles={{ width: "520px", backgroundColor: "#f7fafe" }}
      content={
        <Box className="data-group-modal">
          <p className="content-title">
            <span>Data Group Name</span>
            <input
              type="text"
              name="title"
              className="content-holder ng-valid ng-dirty ng-touched ng-empty"
              value={campaignEdited.title}
              onChange={(e) =>
                setCampaignEdited({ ...campaignEdited, title: e.target.value })
              }
            />
          </p>

          <Box className="content-title">
            <p>Comments</p>

            <textarea
              className="content-holder ng-valid ng-dirty ng-touched ng-empty"
              value={campaignEdited.comments}
              onChange={(e) =>
                setCampaignEdited({
                  ...campaignEdited,
                  comments: e.target.value,
                })
              }
            />
          </Box>

          <p className="content-title">Results</p>

          <table className="padded-table">
            <tbody>
              {campaignEdited.results.map((result, index) => (
                <tr className="ng-scope">
                  <td>
                    <i
                      className="fa fa-times-circle clickable sleek-hover remove-icon"
                      aria-hidden="true"
                      onClick={() => removeEntry(index)}
                    ></i>
                  </td>
                  <td>
                    <span className="tooltip-parent">
                      <i
                        className={`fa fa-users clickable disabled-icon ${
                          result.countTowardsImpressions ? "slategray-font" : ""
                        }`}
                        aria-hidden="true"
                        style={{ padding: "5px" }}
                        onClick={() =>
                          toggleCountTowards(index, "countTowardsImpressions")
                        }
                      ></i>
                      <span className="tooltip-overlay">
                        Include this value in total impression count?
                      </span>
                    </span>

                    <span className="tooltip-parent">
                      <i
                        className={`fa fa-mouse-pointer clickable disabled-icon ${
                          result.countTowardsEngagement ? "slategray-font" : ""
                        }`}
                        aria-hidden="true"
                        style={{ padding: "5px" }}
                        onClick={() =>
                          toggleCountTowards(index, "countTowardsEngagement")
                        }
                      ></i>
                      <span className="tooltip-overlay">
                        Include this value in total engagement count?
                      </span>
                    </span>
                  </td>
                  <td>
                    <input
                      type="text"
                      name="metric"
                      placeholder="metric"
                      className="content-holder ng-pristine ng-untouched ng-valid ng-empty input-metric"
                      value={result.metric}
                      onChange={(e) =>
                        handleUpdateField(index, "metric", e.target.value)
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      name="totalSpent"
                      placeholder="value"
                      className="content-holder ng-pristine ng-untouched ng-valid ng-empty input-total-spent"
                      value={result.value}
                      onChange={(e) =>
                        handleUpdateField(index, "value", e.target.value)
                      }
                    />
                  </td>
                </tr>
              ))}

              <tr className="action-block">
                <td colspan="4" style={{ textAlign: "center" }}>
                  <a
                    href=""
                    onClick={(e) => {
                      e.preventDefault();
                      addEntry();
                    }}
                  >
                    <i
                      className="fa fa-plus-circle"
                      aria-hidden="true"
                      style={{ marginRight: "7px" }}
                    ></i>

                    <span>
                      {campaignEdited.results.length > 0
                        ? "Add Another Metric"
                        : " Add a New Metric"}
                    </span>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </Box>
      }
      action={{
        label: "Done",
        onClick: () => {
          onSubmit(campaignEdited);
          onClose();
        },
      }}
    />
  );
};

export default DataGroupModal;
